import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useRoleMappingsAdd = (id: string) => {
  return useMutation({
    mutationFn: (data) => api.keycloak.createUserRoleMappings(id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось добавить роль',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Роль успешно добавлена',
        type: 'success',
      })
    }
  })
}
